import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'
import type { RoleItem } from '@/api/typings/roles.typing'

export interface RolePayload {
  name: string
  permissions: number[]
}

export function createRoleAction(payload: RolePayload): Promise<ApiResponse<RoleItem>> {
  return api.post<ApiResponse<RoleItem>>('/roles', { ...payload })
}

export function updateRoleAction(id: number, { ...payload }: RolePayload): Promise<ApiResponse<RoleItem>> {
  return api.put<ApiResponse<RoleItem>>(`/roles/${id}`, { ...payload })
}

export function deleteRoleAction(id: number): Promise<ApiResponse<null>> {
  return api.delete<ApiResponse<null>>(`/roles/${id}`)
}
